import { FC } from 'react';

import { IRoutingConfigActor } from '@entities/routing/config-version';

import './actor-label.css';

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

interface IProps {
  actor: IRoutingConfigActor;
}

// The API resolves the actor to a display identity in `value` (an email for
// admins too, since CSP-648) — prefer it so the author column reads uniformly.
// Fallback for payloads without it: admin actions reference an admin UUID,
// integration actions reference an email.
export const ActorLabel: FC<IProps> = ({ actor }) => {
  if (!actor?.reference && !actor?.value) return <span>—</span>;

  const source = actor.type?.split('\\').pop() ?? '';

  if (actor.value) {
    return (
      <span className='routing-author-label' title={`${source} ${actor.reference ?? ''}`.trim()}>
        {actor.value}
      </span>
    );
  }

  const isUuid = UUID_RE.test(actor.reference);
  const label = isUuid ? `${source || 'User'} ${actor.reference}` : actor.reference;

  return (
    <span className='routing-author-label' title={`${source} ${actor.reference}`.trim()}>
      {label}
    </span>
  );
};
